export function contentRenderedEvent(params) {
    return new CustomEvent("growtypeChatContentRendered", {
        detail: params
    });
}
